document.addEventListener('DOMContentLoaded', function () {
  const addon = document.querySelector('[data-product-addon]');

  if (!addon) return;

  const checkbox = addon.querySelector('[data-addon-checkbox]');
  const addonVariantId = addon.dataset.addonVariantId;

  if (!checkbox || !addonVariantId) return;

  const productForm =
    addon.closest('product-information')?.querySelector(
      'form[action*="/cart/add"]'
    ) ||
    document.querySelector(
      'form[action*="/cart/add"]'
    );

  if (!productForm) {
    console.warn('ShopKisu: Product form not found.');
    return;
  }

  productForm.addEventListener('submit', async function (event) {

    // Normal Horizon add-to-cart
    // if addon isn't selected
    if (!checkbox.checked) {
      return;
    }

    // Stop normal product submission
    event.preventDefault();

    const formData = new FormData(productForm);

    const mainVariantId = formData.get('id');

    const quantity = parseInt(
      formData.get('quantity') || 1,
      10
    );

    if (!mainVariantId) {
      console.error('ShopKisu: Main product variant not found.');
      return;
    }

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(mainVariantId),
                quantity: quantity
              },
              {
                id: Number(addonVariantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      /*
       * Get the updated cart
       */

      const cartResponse = await fetch(
        window.Shopify.routes.root + 'cart.js'
      );

      const cart = await cartResponse.json();

      /*
       * Tell Horizon that the cart changed
       */

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,

          detail: {
            resource: cart,

            sourceId: 'shopkisu-product-addon',

            data: {
              itemCount: cart.item_count,
              source: 'shopkisu-product-addon'
            }
          }
        })
      );

      /*
       * Wait for Horizon cart drawer
       */

      customElements.whenDefined(
        'cart-drawer-component'
      ).then(() => {

        const cartDrawer =
          document.querySelector(
            'cart-drawer-component'
          );

        if (cartDrawer) {

          /*
           * Open Horizon cart drawer
           */

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

        } else {

          /*
           * Fallback
           */

          window.location.href =
            window.Shopify.routes.root + 'cart';

        }

      });

    } catch (error) {

      console.error(
        'ShopKisu Product Add-on Error:',
        error
      );

      /*
       * If custom add-to-cart fails,
       * submit the normal Horizon form.
       */

      productForm.submit();

    }

  });

});